import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { CatTableBody } from '@blocks-react/components/TableBody';
import { CatTableRow } from '@blocks-react/components/TableRow';
import { CatTableCell } from '@blocks-react/components/TableCell';
import NameCell from '../custom-cells/NameCell/NameCell';
import KebabCell from '../custom-cells/KebabCell/KebabCell';
import ListTypeCell from '../custom-cells/ListTypeCell/ListTypeCell';
import DealerListTypeCell from '../custom-cells/DealerListTypeCell';
import { SAVED_LIST_COLUMN_IDS } from '../../constants';
import {
  commonItemPropType,
  savedListTableSchema
} from '../../declarations.propTypes';
import TableLineLoader from '../TableLineLoader/TableLineLoader';
import { DEALER } from '@app/constants/affiliations';
const SavedListTableBody = ({
  schema,
  list,
  toastOptions,
  onAddToCartClick,
  onDeleteClick,
  onShareListClick
}) => {
  const userAffiliation = useSelector(s => s.common?.userAffiliation);
  const isDealerUser = userAffiliation === DEALER;

  const isNewListLoading = useSelector(s => s.account.isNewListLoading);
  const getCustomCell = (id, item) => {
    switch (id) {
      case SAVED_LIST_COLUMN_IDS.NAME:
        return <NameCell item={item} />;
      case SAVED_LIST_COLUMN_IDS.ACTIONS:
        return (
          <KebabCell
            item={item}
            toastOptions={toastOptions}
            onAddToCartClick={onAddToCartClick}
            onDeleteClick={onDeleteClick}
            onShareListClick={onShareListClick}
          />
        );
      case SAVED_LIST_COLUMN_IDS.UPDATED_DATE:
        return item.lastUpdate.formattedDate;
      case SAVED_LIST_COLUMN_IDS.LIST_TYPE:
        return isDealerUser ? (
          <DealerListTypeCell
            isSharedWithUCID={item.isSharedWithUCID === 'true'}
          />
        ) : (
          <ListTypeCell type={item[id]} />
        );
      case SAVED_LIST_COLUMN_IDS.CREATED_BY:
        return <span data-cs-mask>{item[id]}</span>;
      default:
        return item[id];
    }
  };
  return (
    <CatTableBody>
      <CatTableRow data-testid="listLoader">
        {isNewListLoading && <TableLineLoader />}
      </CatTableRow>
      {list?.map(item => {
        return (
          <CatTableRow key={item.orderId}>
            {schema?.map(col => (
              <CatTableCell key={col.id} align={col.align} width={col.width}>
                {getCustomCell(col.id, item)}
              </CatTableCell>
            ))}
          </CatTableRow>
        );
      })}
    </CatTableBody>
  );
};

export default SavedListTableBody;

SavedListTableBody.propTypes = {
  list: PropTypes.arrayOf(commonItemPropType),
  schema: savedListTableSchema,
  onAddToCartClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  toastOptions: PropTypes.shape({
    setToastMessage: PropTypes.func,
    clearToastMessage: PropTypes.func
  }),
  onShareListClick: PropTypes.func
};
